// Kanagawa color palettes — values copied from the TePresta reference theme
// (theme-kanagawa.ts). LOTUS is the light mode palette, DRAGON the dark mode
// palette.
export const KANAGAWA_LOTUS = {
    base: '#F2ECBC', // lotusBg
    mantle: '#E6DBA5', // lotusBg2
    crust: '#DCD7BA', // lotusBg3
    surface0: '#CEC8A0', // lighter surface
    surface1: '#BEB890', // border
    surface2: '#AEA880', // darker border
    text: '#54546D', // lotusInk1
    subtext1: '#43436C', // lotusInk2
    subtext0: '#6A6A80', // muted text
    blue: '#4D699B', // lotusBlue
    green: '#6F894E', // lotusGreen
    red: '#C84053', // lotusRed
    peach: '#D67B32', // lotusYellow / orange
    yellow: '#B57E3E', // lotusYellow
    mauve: '#7B52A3', // lotusViolet
    teal: '#597B75', // lotusAqua
    pink: '#C8517A', // lotusPink
    lavender: '#6A7FDB',
    flamingo: '#D8586C',
};
export const KANAGAWA_DRAGON = {
    base: '#1F1F28', // sumiInk1 — main background
    mantle: '#181616', // sumiInk0 — card background
    crust: '#16161D', // sumiInk4 — deepest
    surface0: '#2A2A37', // sumiInk2 — elevated
    surface1: '#363646', // sumiInk3 — border
    surface2: '#54546D', // sumiInk4 — darker border
    text: '#DCD7BA', // fujiWhite — primary text
    subtext1: '#C8C093', // oldWhite — secondary text
    subtext0: '#938056', // boatYellow2 — muted text
    blue: '#7E9CD8', // crystalBlue
    green: '#98BB6C', // springGreen
    red: '#E46876', // waveRed
    peach: '#FFA066', // surimiOrange
    yellow: '#E6C384', // carpYellow
    mauve: '#957FB8', // oniViolet
    teal: '#7AA89F', // springViolet2
    pink: '#D27E99', // sakuraPink
    lavender: '#9CABEB', // soft lavender
    flamingo: '#E8908C',
};
export const KANAGAWA_CHART_COLORS_LOTUS = [
    KANAGAWA_LOTUS.blue,
    KANAGAWA_LOTUS.green,
    KANAGAWA_LOTUS.peach,
    KANAGAWA_LOTUS.mauve,
    KANAGAWA_LOTUS.teal,
    KANAGAWA_LOTUS.red,
    KANAGAWA_LOTUS.pink,
    KANAGAWA_LOTUS.lavender,
    KANAGAWA_LOTUS.flamingo,
    KANAGAWA_LOTUS.yellow,
];
export const KANAGAWA_CHART_COLORS_DRAGON = [
    KANAGAWA_DRAGON.blue,
    KANAGAWA_DRAGON.green,
    KANAGAWA_DRAGON.peach,
    KANAGAWA_DRAGON.mauve,
    KANAGAWA_DRAGON.teal,
    KANAGAWA_DRAGON.red,
    KANAGAWA_DRAGON.pink,
    KANAGAWA_DRAGON.lavender,
    KANAGAWA_DRAGON.flamingo,
    KANAGAWA_DRAGON.yellow,
];
//# sourceMappingURL=kanagawa.js.map